import { format } from 'date-fns'
import * as React from 'react';

import Popup from '../modals/Popup'

const PopupAgreement = (props) => {
  const { onClose, onChange, isSelected, initialSelected } = props;

  const input = initialSelected ? (
    /* <label className="popup__label">Accepted on {format(initialSelected,'MM/DD/YYYY')}</label> */
    null
  ) : (
    <label htmlFor="terms" className="popup__label">
      <input type="checkbox" name="terms" id="terms" className='popup__checkbox' checked={isSelected} onChange={onChange} />
      <span className="popup__checkbox--status"/>
      Accept terms of service?
    </label>
  );

  return (
    <Popup onClose={onClose}>
      <div className="popup__content">
        <h2 className="popup__title">Custodial Account Agreement</h2>
        <p className="popup__text">By establishing a trust account, you authorize Celtic Bank, Member FDIC, to hold your deposits for your benefit in an account (“Trust Account”) by agreeing to the Terms and Conditions at <a href="https://www.relaypayments.com/legal" target="_blank">relaypayments.com/legal</a></p>
      </div>
      <div className='popup__footer'>
        {input}
        <button className="btn btn--prim btn--md btn--white" onClick={onClose}>CONTINUE</button>
      </div>
    </Popup>
  );
};

export default PopupAgreement;
